var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "slide",
      class: { selected: _vm.selectedAddOnData, "have-error": _vm.haveError },
      attrs: { id: _vm.addOn.code },
    },
    [
      _c("div", { staticClass: "slide-image" }, [
        _c(
          "picture",
          {
            directives: [
              {
                name: "lazyload",
                rawName: "v-lazyload",
                value: {
                  src: _vm.addOn.addOnImage,
                  updateCallback: _vm.imageLoadedEvent,
                  canLoad: _vm.canLoad,
                  set: [
                    { width: "800", height: "600", breakpoint: "xs" },
                    { width: "1024", height: "768", breakpoint: "md" },
                    { width: "1280", height: "800", breakpoint: "lg" },
                  ],
                  fit: "crop",
                  align: "center",
                },
                expression:
                  "{\n        src: addOn.addOnImage,\n        updateCallback: imageLoadedEvent,\n        canLoad,\n        set: [\n          { width: '800', height: '600', breakpoint: 'xs' },\n          { width: '1024', height: '768', breakpoint: 'md' },\n          { width: '1280', height: '800', breakpoint: 'lg' },\n        ],\n        fit: 'crop',\n        align: 'center',\n      }",
              },
            ],
            staticClass: "image-wrapper",
          },
          [
            _c("img", {
              staticClass: "image",
              attrs: {
                src: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                alt: _vm.addOn.addOnName,
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "slide-image-gradient-overlay" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "slide-content" }, [
        _c("div", { staticClass: "slide-titles" }, [
          _c("div", { staticClass: "slide-title" }, [
            _vm._v("\n        " + _vm._s(_vm.addOn.addOnName) + "\n      "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "slide-price" }, [
            _vm._v("\n        " + _vm._s(_vm.getPriceLabel) + "\n      "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "slide-utility" }, [
          _c("div", { staticClass: "slide-ctas" }, [
            _c(
              "button",
              {
                staticClass: "slide-ctas--primary",
                attrs: {
                  id: "see-details-" + _vm.addOn.sitecoreId,
                  target: "_self",
                  tabindex: "0",
                  "aria-label":
                    _vm.tc("booking.seeDetails") + " " + _vm.addOn.addOnName,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleCtaClick("see-details")
                  },
                  keypress: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleCtaClick("see-details")
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleCtaClick("see-details")
                    },
                  ],
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.haveError
                        ? _vm.tc("enhancements.actionRequired")
                        : _vm.tc("booking.seeDetails")
                    ) +
                    "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "slide-ctas--add",
                class: { selected: _vm.selectedAddOnData },
                attrs: {
                  id: "add-cta-" + _vm.addOn.sitecoreId,
                  disabled: _vm.isDisabled,
                  "aria-disabled": _vm.isDisabled,
                  "aria-pressed": _vm.selectedAddOnData ? "true" : "false",
                  "aria-label": _vm.selectedAddOnData
                    ? _vm.tc("booking.remove") + " " + _vm.addOn.addOnName
                    : _vm.tc("booking.add") + " " + _vm.addOn.addOnName,
                },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.handleCtaClick("add", $event)
                  },
                  keypress: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleCtaClick("add", $event)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      ) {
                        return null
                      }
                      $event.preventDefault()
                      return _vm.handleCtaClick("add", $event)
                    },
                  ],
                },
              },
              [
                _vm.haveError
                  ? _c("div", { staticClass: "icon-warning-red" })
                  : _vm.selectedAddOnData
                  ? _c("div", {
                      class:
                        "icon-" +
                        (_vm.isLoading && _vm.cartPending
                          ? "loading-black"
                          : "checkmark"),
                    })
                  : _c("div", {
                      class:
                        "icon-" +
                        (_vm.isLoading && _vm.cartPending ? "loading" : "add"),
                    }),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }